import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, ArrowUpRight } from "lucide-react";
import { Nav } from "../components/site/Nav";
import { Footer } from "../components/site/Footer";
import { EASE } from "../components/site/Reveal";

export default function Kickstarter() {
    return (
        <div className="bg-[#050507] min-h-screen flex flex-col" data-testid="kickstarter-page">
            <Nav />
            <main className="flex-1 flex items-center relative overflow-hidden">
                <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[60vw] h-[50vh] bg-[#A855F7]/10 blur-[140px] rounded-full pointer-events-none" />

                <div className="relative max-w-3xl mx-auto px-5 sm:px-8 py-40 text-center">
                    <motion.p
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 0.8 }}
                        className="font-mono-meta text-[11px] tracking-[0.45em] uppercase text-[#A855F7]"
                        data-testid="kickstarter-eyebrow"
                    >
                        Roadmap — Phase 04
                    </motion.p>

                    <h1 className="mt-8 font-display font-extrabold text-white text-4xl sm:text-5xl lg:text-6xl leading-tight">
                        <span className="block overflow-hidden">
                            <motion.span
                                initial={{ y: "112%" }}
                                animate={{ y: "0%" }}
                                transition={{ duration: 1, delay: 0.15, ease: EASE }}
                                className="block"
                            >
                                Kickstarter
                            </motion.span>
                        </span>
                    </h1>
                    <p className="mt-4 font-serif-accent italic text-3xl sm:text-4xl text-slate-300">
                        <span className="block overflow-hidden">
                            <motion.span
                                initial={{ y: "112%" }}
                                animate={{ y: "0%" }}
                                transition={{ duration: 1, delay: 0.3, ease: EASE }}
                                className="block"
                            >
                                Not live — yet.
                            </motion.span>
                        </span>
                    </p>

                    <motion.p
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.9, delay: 0.55, ease: EASE }}
                        className="mt-8 text-base sm:text-lg text-slate-400 leading-relaxed max-w-xl mx-auto"
                        data-testid="kickstarter-body"
                    >
                        Our crowdfunding campaign will launch once the vertical slice is ready
                        to show. We want to earn your support with something real — a world you
                        can see, not just a promise. Follow the build and you'll be the first
                        to know when the campaign goes live.
                    </motion.p>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.9, delay: 0.7, ease: EASE }}
                        className="mt-12 flex flex-wrap items-center justify-center gap-4"
                    >
                        <a
                            data-testid="kickstarter-x-link"
                            href="https://x.com/WRLDKINDStudios"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-3 bg-[#A855F7] text-white font-mono-meta text-[11px] tracking-[0.25em] uppercase px-8 py-4 hover:bg-[#C084FC] transition-colors duration-300"
                        >
                            Get notified on X
                            <ArrowUpRight className="w-3.5 h-3.5" />
                        </a>
                        <Link
                            to="/"
                            data-testid="kickstarter-back-home"
                            className="inline-flex items-center gap-3 border border-white/25 text-white font-mono-meta text-[11px] tracking-[0.25em] uppercase px-8 py-4 hover:border-[#A855F7] hover:text-[#A855F7] transition-colors duration-300"
                        >
                            <ArrowLeft className="w-3.5 h-3.5" />
                            Back to the world
                        </Link>
                    </motion.div>

                    <motion.p
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ duration: 1, delay: 1 }}
                        className="mt-16 font-mono-meta text-[10px] tracking-[0.3em] uppercase text-slate-600"
                    >
                        Concept — Prototype — Vertical Slice — <span className="text-[#A855F7]">Kickstarter</span> — Core Development — Alpha — Beta — Launch
                    </motion.p>
                </div>
            </main>
            <Footer />
        </div>
    );
}
